module.exports = __webpack_public_path__ + "img/footerDao.e454e5fa.png";